import { useState } from "react"
import { flushSync } from "react-dom"
import { usePageContext } from "vike-react/usePageContext"
import FooterDesktop from "./FooterDesktop"
import FooterMobile from "./FooterMobile"
import ContactSalesDialog from "../ContactSalesDialog"

export default function Footer() {
  const pageContext = usePageContext()
  const currentPath = pageContext?.currentPath || pageContext?.urlPathname || (typeof window !== 'undefined' ? window.location.pathname : '/')
  const [dialogOpen, setDialogOpen] = useState(false)

  // Hidden on admin and on the /v/ capture viewer (chromeless share page).
  const shouldHide = ['/admin', '/v/', '/app-signin'].some((prefix) =>
    currentPath?.startsWith(prefix) ||
    (typeof window !== 'undefined' && window.location.pathname.startsWith(prefix))
  )

  if (shouldHide) return null

  function handleDialogClose() {
    document.documentElement.style.scrollBehavior = "auto"
    flushSync(() => setDialogOpen(false))
    document.documentElement.style.scrollBehavior = ""
  }

  return (
    <div>
      <div className="hidden lg:block">
        <FooterDesktop onOpenContactSales={() => setDialogOpen(true)} />
      </div>

      <div className="block lg:hidden">
        <FooterMobile onOpenContactSales={() => setDialogOpen(true)} />
      </div>

      <ContactSalesDialog isOpen={dialogOpen} onClose={handleDialogClose} />
    </div>
  )
}
